export const NEW_ACCOUNT = {
  id: "",
  firstname: "",
  lastname: "",
  email: "",
  createdDate: "0000-00-00",
  updatedDate: "0000-00-00",
  accessLevel: null,
  pbxes: [],
};

export const NEW_DESTINATION = {
  name: "",
  exten: "",
  destination: "",
  ringSeconds: 60,
  forceCallerId: null,
  overflow: null,
};

export const NEW_PBX = {
  name: "",
  maxConcurrentLines: 4,
  maxSippeers: 4,
  zip: "",
  context: "",
  accountcode: "",
  defaultCountryCallingCode: 32,
  phoneNumbers: [],
  defaultPhoneNumber: "",
  internalPhonebookToken: "",
  wallpaper: { id: null },
  screensaver: { id: null },
  partner: { id: null },
};

export const NEW_BLOCKLIST = {
  allowExternalIn: true,
  allowExternalOut: true,
  type: null,
  name: "",
  rules: [],
};

export const NEW_GROUP = {
  name: "",
  exten: "",
  type: "RingallGroup",
  callRecording: "undefined",
  members: [],
  repeat: 0,
  ringSeconds: 60,
  musiconhold: null,
  overflow: null,
};

export const NEW_MUSICONHOLD = {
  name: "",
  random: false,
  entries: [],
};

export const NEW_CLICK_TO_DIAL = {
  username: "",
  password: "",
  sippeers: [],
};

export const NEW_HOLIDAY_SET = {
  name: "",
  private: 0,
  holidays: [],
};

export const NEW_INBOUND = {
  name: "",
  forceCallerId: null,
  did: "",
  overflow: null,
  callRecording: "no",
  webhooks: [],
};

export const NEW_IVR = {
  name: "",
  exten: "",
  inputTimeout: 10,
  repeat: 1,
  options: [],
  timeoutOverflow: null,
};

export const NEW_OUTBOUND = {
  name: "",
  prefix: "",
  callerId: "",
  destinationPrefixes: [],
};

export const NEW_PHONEBOOK = {
  name: "",
  groups: [],
  token: "",
};

const day = [
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
];
export const NEW_TIMETABLE = {
  name: null,
  overflow: null,
  conditions: {
    mon: [...day],
    tue: [...day],
    wed: [...day],
    thu: [...day],
    fri: [...day],
    sat: [...day],
    sun: [...day],
  },
  rules: [],
  holidaySets: [],
};

export const NEW_QUEUE = {
  name: "",
  exten: "",
  language: "en_US",
  announce: "no",
  announceFrequency: null,
  announceHoldtime: "no",
  announcePosition: "no",
  periodicAnnounce: null,
  extensions: [],
  joinEmpty: "no",
  leaveWhenEmpty: "yes",
  maxlen: 0,
  members: [],
  minAnnounceFrequency: 40,
  periodicAnnounceFrequency: null,
  retry: 5,
  musiconhold: "Default",
  recording: false,
  reportholdtime: "no",
  ringInUse: "no",
  autofill: "yes",
  strategy: "ringall",
  timeout: 30,
  wrapUpTime: 0,
  ringSeconds: null,
};

export const NEW_CONFERENCE = {
  announceJoinLeave: false,
  announceOnlyUser: true,
  announceUserCountAll: true,
  enableAdmin: false,
  exten: "",
  language: "en_US",
  maxMembers: 5,
  moh: null,
  name: "",
  pinAdmin: null,
  pinParticipant: null,
  quitOnAdminLeave: false,
  record: false,
  waitForAdmin: false,
};

export const NEW_PARTNER = {
  name: null,
  supportEmail: null,
  salesEmail: null,
};

export const NEW_PHONE_NUMBER = {
  start: "+",
  end: "+",
  type: "fixed",
  pbx: null,
  partner: null,
  adminComment: null,
  partnerComment: null,
};

export const NEW_USER = {
  name: "",
  exten: null,
  outboundCidNumber: null,
  postalcode: null,
  callRecording: "OFF",
  callLimit: 10,
  codecs: ["alaw"],
  ringSeconds: 60,
  moh: "Default",
  phonebooks: [],
  lineKeys: [],
  password: "",
  showInternalPhonebook: true,
  enableClickForYealink: 0,
  overflow: null,
  lineKeyTemplateAccounts: [],
  distinctiveRingtones: [],
  ringtoneId: 1,
  internalRingtoneId: 1,
  labelFormat: "name",
  callWaitingTone: true,
  missedCallLog: true,
  deviceLanguage: "dutch",
  blfTransferMode: "attendedTransfer",
  allowDnd: true,
  blfPickupIndication: false,
  callWaiting: true,
  semiAttendedTransfer: false,
  dssKeyLength: "default",
};

export const NEW_VOICEMAIL = {
  name: "",
  exten: "",
  email: "",
  playGreeting: true,
};

export const NEW_LINE_KEY_TEMPLATE = {
  name: "",
  description: null,
  lineKeys: [],
  preferredDevice: {
    id: 30,
    type: "SIP-T46U",
    brand: "Yealink",
    lineKeyPages: 3,
    lineKeys: 27,
  },
};

export const NEW_WEBHOOK = {
  name: "",
  url: "",
  onAnswer: 0,
  requestType: "json_body",
  enabled: true,
  useNewWebhooks: true,
  customHeader: {
    name: "",
    value: "",
  },
};

export const NEW_CALL_PARKING = {
  exten: "",
  mohId: null,
  name: "",
  rangeEnd: "",
  rangeStart: "",
  returnCallAfterTimeout: false,
  timeout: 120,
  timeoutOverflow: null,
};

export const NEW_INTERCOM = {
  name: "",
  exten: "",
  members: [],
  announcementId: null,
  dialInUse: false,
  fullDuplexAudio: false,
  playBeep: true,
};

export const NEW_DAYNIGHT = {
  name: "",
  exten: "",
  state: true,
  onOverflow: null,
  offOverflow: null,
};

export const NEW_DISTINCTIVE_RINGTONE = {
  name: "",
  ringtoneId: null,
  defaultForNewAccounts: false,
};

export const NEW_TOKEN = {
  name: "",
  description: "",
};
